import {ConnectionUserWithConnectionAccepted} from '@lib/store';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {ListHeader} from '../ListHeader';
import {Card} from '@atoms';
import {Avatar} from '@molecules';
import {AddConnectionsCard, ConnectionsCardCell} from '@organisms';
import {cn} from '@utils';
import {useModal} from '@hooks';
import {ConnectionSectionItem} from './ConnectionSectionItem';

export const ConnectionsSection = ({
  acceptedConnections,
  className,
}: {
  acceptedConnections: ConnectionUserWithConnectionAccepted[];
  className?: string;
}) => {
  const {t} = useTranslation();
  const {addPages, openModal} = useModal();
  const navigate = useNavigate();

  const handleOpenAddConnections = () => {
    addPages([<AddConnectionsCard />]);
    openModal();
  };

  return (
    <Card className={cn('flex flex-col py-8 gap-6', className)}>
      <ListHeader
        title={t('connection:ConnectedColleagues', {count: acceptedConnections.length})}
        className="px-4 sm:px-6 md:px-8"
        action={handleOpenAddConnections}
      />

      <div className="grid divide-y">
        {acceptedConnections.map((user) => (
          <ConnectionSectionItem
            user={user}
            key={user.id}
          />
        ))}
      </div>
    </Card>
  );
};
